import ArrowBackIosNewOutlined from '@mui/icons-material/ArrowBackIosNewOutlined';
import { Box, Stack, Button } from '@mui/material';
// import { Printer } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// Components
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';
// import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
// import IconFeather from 'src/components/common/Icon';
import InvoiceTemplate from 'src/components/InvoiceTemplate';
import { TypeTabSetting } from 'src/features/Setting/config';

const InvoiceDetail = ({ billingId }: { billingId: string }) => {
  const { t } = useTranslation();
  const [, setSearchParam] = useSearchParams();

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" my={3}>
        <Button
          sx={{ cursor: 'pointer' }}
          variant="text"
          color="primary"
          onClick={() => setSearchParam({ tab: TypeTabSetting.payment_history })}
        >
          <ArrowBackIosNewOutlined sx={{ mr: 1, fontSize: 14 }} />
          {t('global.back')}
        </Button>
        <Breadcrumbs
          listItem={[
            {
              text: t('payment_history.title'),
            },
            {
              text: 'BillingID',
            },
            {
              text: `#${(billingId || '').toUpperCase()}`,
            },
          ]}
        />
        {/* <ButtonWithLoading variant="outlined" color="secondary" startIcon={<IconFeather icon={<Printer />} />}>
          {t('global.print')}
        </ButtonWithLoading> */}
      </Stack>
      <Stack alignItems="center" pt={2}>
        <SectionErrorBoundary resetKey="InvoiceDetail" sectionName="InvoiceDetail">
          <InvoiceTemplate width="80%" invoiceId={billingId} />
        </SectionErrorBoundary>
      </Stack>
    </Box>
  );
};

export default InvoiceDetail;
